<template>
    <div class="ExamQuestionBank-header">
        <div class="w">
            <!-- header -->
            <SecondHead activeIndex="8" textColor="#333" color="#333"></SecondHead>
	
		</div>
        <router-view></router-view>
    </div>
</template>

<script>
import SecondHead from "@/components/SecondHead"
export default {
    name: 'ExamQuestionBank',
    components: {
        SecondHead,
    },
    data() {
        return {

        }
    },
    created() {

    }
}
</script>

<style lang="scss" scoped>
</style>
